import { useEffect, useRef, useState } from "react";
import Tooltip from "@tippyjs/react";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';

import Quoteservice from "../../../../services/contract/Quotes/quotesServices";
import { getTrans as t } from "../../../../Localization/translations";
import Helper from "../../../../Helper";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import { useNavigate } from "react-router-dom";

function QuoteView({ quote_id, sethide }) {
  const navigate = useNavigate();
  const [hasProcessingErrors, setHasProcessingErrors] = useState(false);
  const [quotedata, setQuoteData] = useState([]);
  const [loading, setLoading] = useState([]);
  const [outstanding_ar, setOutstanding_Ar] = useState("");
  const [unbilled_ar, setUnbilled_Ar] = useState("");
  const [future_rental, setFuture_Rental] = useState("");
  const [book_value, setBook_Value] = useState("");
  const [unearned_income, setUnearned_Income] = useState("");
  const [computed_payoff, setComputed_Payoff] = useState("");
  const [payoff_fee, setPayoff_Fee] = useState("");
  const [payOff_amount, setPayOff_Amount] = useState("");
  const [prior_outstanding, setPrior_Outstanding] = useState("");
  const [total_due, setTotal_due] = useState("");
  const [quotelineid, setQuotelineid] = useState("");
  const form = useRef();
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const getQuote = () => {
    setLoading(true);
    Quoteservice.getquote(quote_id).then((response) => {
      setQuoteData(response.data.response);
      setOutstanding_Ar(response.data.response.quote_lines[0].outstanding_ar);
      setUnbilled_Ar(response.data.response.quote_lines[0].unbilled_ar);
      setFuture_Rental(response.data.response.quote_lines[0].future_rental);
      setBook_Value(response.data.response.quote_lines[0].book_value);
      setUnearned_Income(response.data.response.quote_lines[0].unearned_income);
      setComputed_Payoff(response.data.response.quote_lines[0].computed_payoff);
      setPayoff_Fee(response.data.response.quote_lines[0].payoff_fee);
      setPayOff_Amount(response.data.response.quote_lines[0].payOff_amount);
      setPrior_Outstanding(
        response.data.response.quote_lines[0].prior_outstanding
      );
      setQuotelineid(
        response.data.response.quote_lines[0].id
      );
      setTotal_due(response.data.response.quote_lines[0].total_due);
      setLoading(false);
    })
  };
  // Live totals: the fee input can be empty or edited before saving.
  const payoffAmountCalc = (parseFloat(payoff_fee) || 0) + (parseFloat(computed_payoff) || 0);

  const handleshowHide = () => {
    sethide(false);
  };

  const handleCancel = () => {
    sethide(false)
  }

  useEffect(() => {
    getQuote();
  }, []);

  const handleprocess = () => {
    setHasProcessingErrors(false);
    Quoteservice.quoteprocess(
      quote_id,
    ).then((response) => {
      if (response.data.success === 1) {
        toast.success(response.data.response)
        setTimeout(() => {
          sethide(false)
        }, 2000)
      }
      else {
        toast.error(response.data.error)
      }
    }).catch((error) => {
      if (error.response && error.response.status === 400) {
        setHasProcessingErrors(true); // Show the Review Errors link
        toast.error(error.response.data.error || "Data Quality Check Failed.", {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
      } else {
        toast.error("Failed to process payoff");
      }
    });
  }

  const handleRegister = () => {
    Quoteservice.editquoteline(
      quotelineid,
      quote_id,
      payoff_fee,
      payOff_amount,
      outstanding_ar,
      unbilled_ar,
      computed_payoff,
      quotedata.termination_type
    ).then(
      (response) => {
        if (response.data.success == 1) {
          toast.success(`${response.data.response}`)
          setTimeout(() => {
            sethide(false);

          }, 2000)

        }
        else {

          toast.error(`${response.data.error}`)
        }
      }
    )
  }

  return (
    <>
      {
        loading === true ? (
          ""
        ) : (
          <>
            <ToastContainer
              autoClose={2000}
            />
            <div className="header">
              <h4 className="mb-3 pt-3 tc" onClick={handleshowHide}>
                {<i className="fa  fa-solid fa-arrow-left"></i>}{" "}
                {t("View Payoff Quote")}
              </h4>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="row">
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <label className="col-lg-12 col-form-label">
                          {" "}
                          {t("Payoff Quote Number")}{" "}
                          <Tooltip content={t("QuoteNumber_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <div className="party-detail-font">
                            {quotedata.quote_number}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="row">
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <label className="col-lg-12 col-form-label">
                          {" "}
                          {t("Termination Type")}{" "}
                          <Tooltip content={t("TerminationType_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <div className="party-detail-font">
                            {quotedata.termination_type}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-xl-6">
                    <div className="row">


                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <label className="col-lg-12 col-form-label">
                          {t("Termination Date")}{" "}
                          <Tooltip content={t("TerminationDate_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-xl-6" >
                          <span className="party-detail-font">
                            {Helper.DateNormal(quotedata.termination_date)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="col-lg-12 col-form-label">
                      {t("Payoff Quote Status")}{" "}
                      <Tooltip content={t("QuoteStatus_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-3 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {quotedata.quote_status}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-xl-3 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="col-lg-12 col-form-label">
                      {t("Expiry Date")}{" "}
                      <Tooltip content={t("ExpiryDate_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-4 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {Helper.DateNormal(quotedata.expiry_date)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="header">
                  <h6
                    className="mb-3 pt-3 text-bold mt-3"
                  >
                    {t("Payoff Quote Details")}
                  </h6>
                </div>
                <div className="row">
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Outstanding Receivable")}{" "}
                      <Tooltip content={t("OutstandingAR_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex " style={{ justifyContent: 'space-between' }}>
                      <span className=" party-detail-font">
                        {outstanding_ar ? Helper.Amount(outstanding_ar) : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Unbilled Receivable")}{" "}
                      <Tooltip content={t("UnbilledAR_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {unbilled_ar ? Helper.Amount(unbilled_ar) : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Future Rental")}{" "}
                      <Tooltip content={t("FutureRental_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {future_rental ? Helper.Amount(future_rental) : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Unearned Income")}{" "}
                      <Tooltip content={t("UnearnedIncome_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {unearned_income
                          ? Helper.Amount(unearned_income)
                          : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Book Value")}{" "}
                      <Tooltip content={t("BookValue_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {book_value ? Helper.Amount(book_value) : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Residual Booked")}{" "}
                      <Tooltip content={t("ResidualBooked_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {quotedata.length > 0
                          ? quotedata.quote_lines[0].outstanding_ar
                          : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Prior Outstanding")}{" "}
                      <Tooltip content={t("PriorOutstanding_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {prior_outstanding
                          ? Helper.Amount(prior_outstanding)
                          : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Computed Payoff")}{" "}
                      <Tooltip content={t("ComputedPayoff_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {computed_payoff
                          ? Helper.Amount(computed_payoff)
                          : "0.00"}
                      </span>
                    </div>
                  </div>

                  <div className="col-xl-6 mt-3 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Payoff Fee")}{" "}
                      <Tooltip content={t("PayoffFee_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    {
                      quotedata.quote_status === "Processed" || quotedata.quote_status === "Cancelled" ?
                        <div className="col-xl-6  d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {payoff_fee ? Helper.Amount(payoff_fee) : "0.00"}
                          </span>
                        </div>
                        :
                        <>
                          <div className="col-xl-6 mt-1 d-flex" style={{ justifyContent: 'space-between' }}>
                            <input type="number" className="form-control party-detail-font"
                              value={payoff_fee}
                              onChange={(e) => setPayoff_Fee(e.target.value)}
                            >

                            </input>
                          </div>
                        </>
                    }
                  </div>
                  <div className="col-xl-6 mt-3 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Payoff Amount")}{" "}
                      <Tooltip content={t("PayoffAmount_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    {
                      quotedata.termination_type === "Return" ?
                        <>
                          <div className="col-xl-6  d-flex" style={{ justifyContent: 'space-between' }}>
                            <span className="party-detail-font">
                              {Helper.Amount(payoffAmountCalc)}
                            </span>
                          </div>
                        </>
                        :

                        <div className="col-xl-6  d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className="party-detail-font">
                            {Helper.Amount(payoffAmountCalc)}
                          </span>
                        </div>
                    }
                  </div>
                  <div className="col-xl-6 mt-3 d-flex" style={{ justifyContent: 'space-between' }}>
                    <label className="sub-title tc">
                      {t("Total Payoff Outstanding")}{" "}
                      <Tooltip content={t("TotalPayoffOutstanding_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="col-xl-6 mt-1" style={{ justifyContent: 'space-between' }}>
                      <span className="party-detail-font">
                        {/* {total_due ? payoff_fee !== "" ? Helper.Amount(parseInt((payoff_fee)) + parseInt((computed_payoff)) + parseInt((prior_outstanding))) : Helper.Amount(parseInt((0)) + parseInt((computed_payoff)) + parseInt((prior_outstanding))) : "0.00"} */}
                        {Helper.Amount(payoffAmountCalc + (parseFloat(prior_outstanding) || 0))}
                      </span>
                    </div>
                  </div>
                </div>
                <Form ref={form} onSubmit={handleSubmit(handleRegister)} method="POST">
                  <div className="text-left py-3 mt-5">
                    <input type="hidden" id="assetId" />
                    <button type="button" className="asset-cancel btn btn-secondary btn-md"
                      onClick={handleCancel}

                    >
                      {
                        quotedata.quote_status === "Processed" || quotedata.quote_status === "Cancelled" ?
                          t('Back') :
                          t("Cancel")
                      }
                    </button>&nbsp;&nbsp;
                    {
                      quotedata.quote_status === "Processed" || quotedata.quote_status === "Cancelled" ?
                        "" :
                        <>
                          <button type="button" onClick={() => handleprocess()} className=" btn btn-primary btn-md"

                          >{t("Process")}</button>&nbsp;&nbsp;
                        </>
                    }
                    {
                      quotedata.quote_status === "Processed" || quotedata.quote_status === "Cancelled" ?
                        "" :
                        <>
                          <button type="submit" className="btn-assets border-0 btn btn-primary btn-gradient-primary btn-md">
                            {
                              loading === false ? (
                                t('Save')
                              ) : (
                                <ButtonLoading />
                              )
                            }
                          </button>
                        </>
                    }
                    {hasProcessingErrors && (
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#dc3545",
                          cursor: "pointer",
                          textDecoration: "underline",
                          fontWeight: "500",
                          marginLeft: "15px"
                        }}
                        onClick={() => navigate("/processing-failure-log", { state: { contract_id: quotedata.contract } })}
                      >
                        {t("Review Errors")}
                      </span>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </>
        )
      }
    </>
  );
}

export default QuoteView;
